import $ from 'jquery';

function NaviCtrl() {
	this.$win      = $(window);
	this.$htmlBody = $('html, body');
	this.$body     = $('body');
	this.$target   = $('#gNavi');
	this.$btnOpen  = $('#gnaviToggle');
  this.$content = $('#main');
  this.breakpoint = 1490;
  this.timer = null;

	this.scrollState = 0;

	this.open  = this.open.bind(this);
  this.close = this.close.bind(this);
  this.resize = this.resize.bind(this);

  this.init();
}

NaviCtrl.prototype.init = function() {
	this.$btnOpen.on('click', this.open);
  this.$target.find('a').on('click', this.close);
  this.$win.on('resize', this.resize);
}

NaviCtrl.prototype.resize = function () {
  if (this.matchMedia(this.breakpoint)) {
    this.removeDrawerActive();
    this.timer = null;
  }
}

NaviCtrl.prototype.matchMedia = function (n) {
  return window.matchMedia('(min-width:' + n + 'px)').matches;
}

NaviCtrl.prototype.addDrawerActive = function () {
  this.$htmlBody.addClass('drawer-active');
  this.$target.addClass('drawer-active');
  this.$btnOpen.addClass('drawer-active');
}

NaviCtrl.prototype.removeDrawerActive = function () {
  this.$htmlBody.removeClass('drawer-active');
  this.$target.removeClass('drawer-active');
  this.$btnOpen.removeClass('drawer-active');
}

NaviCtrl.prototype.translateY = function (scrollPosition) {
  var pos = scrollPosition || 0;
  this.$content.css('transform', 'translateY(' + pos + ')');
}

NaviCtrl.prototype.open = function() {
  if (this.matchMedia(this.breakpoint)) {
    this.removeDrawerActive();
    return;
  }

  if (!this.$target.hasClass('drawer-active')) {
    let scrollTop = this.$win.scrollTop();
    this.scrollState = scrollTop;
    this.addDrawerActive();
    this.translateY(-scrollTop + 'px');
  } else {
    this.removeDrawerActive();
    this.$win.scrollTop(this.scrollState);
    this.translateY();
  }
}

NaviCtrl.prototype.close = function() {
  this.removeDrawerActive();
  if (this.matchMedia(this.breakpoint)) {
    return;
  }

  this.$win.scrollTop(this.scrollState);
  this.translateY();
}

export default NaviCtrl;